import { request } from '../request'
// 获取全年数据
export function getSettleStatisticsYear(data) {
  return request({
    url: '/wjsettlement/center/statistic/settleStatisticsYear',
    method: 'get',
    params: data
  })
}
// 获取结算概况汇总数据
export function getAllSettleStatistics(data) {
  return request({
    url: '/wjsettlement/center/statistic/settleStatistics',
    method: 'get',
    params: data
  })
}
// 按项目
export function getProject(data) {
  return request({
    url: '/wjsettlement/center/statistic/settleTypeForProject',
    method: 'get',
    params: data
  })
}
// 按部门
export function getDept(data) {
  return request({
    url: '/wjsettlement/center/statistic/settleTypeForDept',
    method: 'get',
    params: data
  })
}
// 按调查员
export function getInvestigator(data) {
  return request({
    url: '/wjsettlement/center/statistic/settleTypeForInvestigator',
    method: 'get',
    params: data
  })
}
// 按发起人
export function getForCreate(data) {
  return request({
    url: '/wjsettlement/center/statistic/settleTypeForCreate',
    method: 'get',
    params: data
  })
}
// 按项目类型
export function getProjectType(data) {
  return request({
    url: '/wjsettlement/center/statistic/settleTypeForProjectType',
    method: 'get',
    params: data
  })
}
// 按项目类型
export function getAllYears() {
  return request({
    url: '/wjsettlement/center/statistic/settleYears',
    method: 'get',
  })
}
